<template>
  <v-list dense class="p-0">
    <draggable
      @change="changeOrder"
      class="main-draggable"
      :list="elements"
      :group="{ name: 'g1' }"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <template v-for="(item, index) in elements">
          <v-list-group v-if="item.children" prepend-icon="mdi mdi-chevron-down" :key="index" value="true" v-model="item.open" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <div class="menu-group-buttons">
                <v-icon v-if="item.nameGrandParent === null && !item.suspended" small color="green" @click="addItem(item)">add</v-icon>
                <v-icon small color="green" @click="showItem(item)">edit</v-icon>
                <v-icon small color="red darken-3" @click="removeItem(item)">delete</v-icon>
              </div>
            </template>
            <devDraggableNested v-if="item.children" :elements="item.children" />
          </v-list-group>

          <v-list-item :key="index" v-else link>
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-title v-text="item.name"></v-list-item-title>

            <div class="menu-group-buttons">
              <v-icon v-if="item.nameGrandParent === null && !item.suspended" small color="green" @click="addItem(item)">add</v-icon>
              <v-icon small color="green" @click="showItem(item)">edit</v-icon>
              <v-icon small color="red darken-3" @click="removeItem(item)">delete</v-icon>
            </div>
          </v-list-item>
        </template>
      </transition-group>
    </draggable>
  </v-list>
</template>

<script>
import draggable from 'vuedraggable';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  name: 'devDraggableNested',

  data: () => ({
    drag: false
  }),

  props: {
    elements: { type: Array, default: () => [], required: true }
  },

  components: {
    draggable
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    }
  },

  methods: {
    addItem(item) {
      this.$emit(HANDLERS.ADD_ITEM, item);
    },

    showItem(item) {
      this.$emit(HANDLERS.SHOW_ITEM, item);
    },

    removeItem(item) {
      this.$emit(HANDLERS.REMOVE_ITEM, item);
    },

    changeOrder(event) {
      this.$emit(HANDLERS.CHANGE_ORDER, event);
    }
  }
};
</script>

<style lang="scss">
.v-application--is-ltr {
  .main-draggable {
    width: 100%;

    .v-list-item {
      box-shadow: 0px 0px 3px 1px #d0d0d0;
      margin-bottom: 8px;
    }
    .v-list-item__icon {
      display: flex;
      justify-content: center;
      margin-right: 10px;
    }
    .v-list-group.v-list-group--sub-group .v-list-group__header {
      padding-left: 16px;
    }

    .v-list-group--sub-group .v-list-item__icon:first-child {
      margin-right: 32px;
    }

    .v-list--dense .v-list-item .v-list-item__icon {
      margin-right: 16px;
    }

    .v-list-group--sub-group .v-list-group__items .v-list-item {
      margin-left: 50px;
      padding-left: 20px;
    }
  }

  .v-list-group.v-list-group--active {
    .v-list-group__items {
      overflow: initial;

      .v-list {
        .main-draggable {
          .v-list-group.v-list-group--sub-group {
            .v-list-item {
              padding-left: 15px;
            }
          }

          .v-list-group.v-list-group--active {
            .v-list-item {
              padding-left: 15px;
            }

            .v-list-group__items {
              padding-left: 5px;
              margin-left: 50px;
            }
          }
        }
      }
    }
  }

  .menu-group-buttons {
    flex-direction: row;
    display: flex;

    .v-icon {
      transform: scale(1);
      transition: all 0.5s ease-in;
      margin-right: 5px;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        transform: scale(1.5);
        transition: all 0.5s ease-in-out;
      }
    }
  }
}
</style>
